import styled from 'styled-components'
import { rem } from 'polished'

import type { TripListRowType } from './tripListTypes'
import TripListTypeIcon from './TripListTypeIcon'
import TripListFilterMenuItem from './TripListFilterMenuItem'

const FilterTypeIcon = styled(TripListTypeIcon)`
  width: ${rem(32)};
  height: ${rem(32)};
`

interface Props {
  type: TripListRowType
  label: string
  count: number
  selected: boolean
  onToggle: (type: TripListRowType) => void
}

function TypeFilterMenuItem({ type, label, count, selected, onToggle }: Props) {
  return (
    <TripListFilterMenuItem
      value={type}
      label={label}
      count={count}
      selected={selected}
      icon={<FilterTypeIcon type={type} />}
      onToggle={onToggle}
    />
  )
}

export default TypeFilterMenuItem
